import React, { Fragment, useState, useEffect } from "react";
import { ThemeProvider } from "styled-components";
import { interiorTheme } from "common/theme/interior";
import Layout from "../containers/Home/Layout";
import "common/assets/css/main-page.css";
import ServicesWrapper from "../containers/Home/services.style";
import TitleBar2 from "common/components/Titlebar2";
import Seo from "components/seo";
import { Link } from "gatsby";
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import Fade from "react-reveal/Fade";

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay]);

const Services = () => {
  const [menServices, setMenServices] = useState([]);
  const [womenServices, setWomenServices] = useState([]);
  const [offerData, setOfferData] = useState(null);
  const [pageData, setPageData] = useState({});
  const [bannerData, setBannerData] = useState({});
  const [seoData, setSeoData] = useState({
    canonical: "https://www.radiancehairstudio.com/services.php",
  });
  const [schemaData, setSchemaData] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          "https://radianceadmin.manageprojects.in/api/hair-services"
        );
        const data = await response.json();

        if (data.success) {
          // Set services data
          const menServicesData = data.data.men_services[0].sliders.map(
            (service) => ({
              title: service.imagetitle,
              image: `${service.slider_img}`,
              link: service.pageurl,
            })
          );

          const womenServicesData = data.data.women_services[0].sliders.map(
            (service) => ({
              title: service.imagetitle,
              image: `${service.slider_img}`,
              link: service.pageurl,
            })
          );

          // Set offer data
          const offer = {
            subtitle: data.data.women_services[0].offer_subtitle,
            title: data.data.women_services[0].offer_title,
            description: data.data.women_services[0].offer_description,
            banner: `${data.data.women_services[0].offerbanner}`,
          };

          // Set page content
          const pageContent = {
            heading: data.data.men_services[0].heading,
            subHeading: data.data.men_services[0].sub_heading,
            description: data.data.men_services[0].description,
            seo_title: data.data.men_services[0].seo_title,
            seo_description: data.data.men_services[0].seo_description,
            seo_keywords: data.data.men_services[0].seo_keywords,
            schema_data: data.data.men_services[0].schema_data
          };

          // Set banner data
          const bannerdata = {
            slidermantitle: data.data.men_services[0].slider_title,
            sliderwomentitle: data.data.women_services[0].slider_title,
            bannertitle: data.data.men_services[0].banner_title,
            bannerimg: data.data.men_services[0].pagebanner,
            mainbanner: `${data.data.men_services[0].pagebanner}`,
          };

          // Update state
          setMenServices(menServicesData);
          setWomenServices(womenServicesData);
          setOfferData(offer);
          setPageData(pageContent);
          setBannerData(bannerdata);

          // Update SEO data from API
          if (pageContent.seo_title || pageContent.seo_description || pageContent.seo_keywords) {
            setSeoData({
              title: pageContent.seo_title || seoData.title,
              description: pageContent.seo_description || seoData.description,
              keywords: pageContent.seo_keywords 
                ? pageContent.seo_keywords.split(',').map(k => k.trim()) 
                : seoData.keywords,
              canonical: "https://www.radiancehairstudio.com/services.php",
            });
          }

          // Parse schema data
          if (pageContent.schema_data) {
            try {
              const parsedSchema = JSON.parse(pageContent.schema_data);
              setSchemaData(parsedSchema);
            } catch (error) {
              setSchemaData({});
            }
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const CardNewBg = ({ title, image, link }) => {
    return (
      <div
        className="serviceCardNew2 cardbg"
        style={{ background: `url(${image})` }}
      >
        <Link to={link}>
          <div className="row" style={{ alignItems: "center" }}>
            <div className="col-md-12">
              <h2>{title}</h2>
              <a className="btncard" href={link}>
                Get Now
              </a>
            </div>
          </div>
        </Link>
      </div>
    );
  };

  const swiperBreakpoints = {
    767: { slidesPerView: 2, spaceBetween: 20 },
    768: { slidesPerView: 2, spaceBetween: 20 },
  };

  return (
    <ThemeProvider theme={interiorTheme}>
      <Fragment>
        <Seo {...seoData} schemaData={schemaData} />
        <Layout>
          <ServicesWrapper>
            <div className="services-body">
              <main className="services-page">
                {/* Title Bar */}
                <section
                  className="title-bar"
                  style={{ backgroundImage: `url(${bannerData.mainbanner})` }}
                >
                  <div className="title-bar-overlay"></div>
                  <div className="section-container">
                    <h1 className="title-bar-heading">{bannerData.bannertitle}</h1>
                    <h2 className="title-bar-breadcrumb" style={{ color: "#fff" }}>
                      <Link to="/">Home</Link> /{" "}
                      <Link to="#">{bannerData.bannertitle}</Link>
                    </h2>
                  </div>
                </section>

                <section className="title-bar-separator">
                  <img
                    className="separator-image"
                    alt=""
                    src="/images/separator.png"
                  />
                </section>

                {/* Intro Section */}
                <section className="services-section-one">
                  <div className="myContainer">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="headB">
                          <Fade left>
                            <p>{pageData.subHeading}</p>
                            <h3 className="title">{pageData.heading}</h3>
                          </Fade>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="firstpara">
                          <Fade right>
                            <div
                              className="who-we-are-sec pt-20"
                              dangerouslySetInnerHTML={{
                                __html: pageData.description,
                              }}
                            />
                          </Fade>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                {/* Men's Services Slider */}
                <section className="services-section-two">
                  <div className="section-container">
                    <div className="content-area-center">
                      <h2 className="title">{bannerData.slidermantitle}</h2>
                      <Swiper
                        spaceBetween={0}
                        slidesPerView={1}
                        loop={true}
                        navigation
                        autoplay={{ delay: 3000 }}
                        pagination={{ clickable: true }}
                        breakpoints={swiperBreakpoints}
                        initialSlide={2}
                      >
                        {menServices.map((service, index) => (
                          <SwiperSlide key={index}>
                            <CardNewBg {...service} />
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    </div>
                  </div>
                </section>

                {/* Women's Services Slider */}
                <section
                  className="services-section-two"
                  style={{ background: "#F4F3F3" }}
                >
                  <div className="section-container">
                    <div className="content-area-center">
                      <h2 className="title">{bannerData.sliderwomentitle}</h2>
                      <Swiper
                        spaceBetween={0}
                        slidesPerView={1}
                        loop={true}
                        navigation
                        autoplay={{ delay: 3000 }}
                        pagination={{ clickable: true }}
                        breakpoints={swiperBreakpoints}
                        initialSlide={2}
                      >
                        {womenServices.map((service, index) => (
                          <SwiperSlide key={index}>
                            <CardNewBg {...service} />
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    </div>
                  </div>
                </section>

                {/* Offer Section */}
                {offerData && (
                  <section className="services-section-four">
                    <div className="section-container">
                      <div
                        className="offer-container"
                        style={{
                          backgroundImage: `url(${offerData.banner})`,
                        }}
                      >
                        <div className="offer-container-content">
                          <h2 className="title-1">{offerData.subtitle}</h2>
                          <h3
                            className="title-2"
                            dangerouslySetInnerHTML={{
                              __html: offerData.title,
                            }}
                          />
                          <div
                            className="title-3"
                            dangerouslySetInnerHTML={{
                              __html: offerData.description,
                            }}
                          />
                          <a className="border-button" href="/appointment.php">
                            BOOK AN APPOINTMENT
                          </a>
                        </div>
                      </div>
                    </div>
                  </section>
                )}
              </main>
            </div>
          </ServicesWrapper>
        </Layout>
      </Fragment>
    </ThemeProvider>
  );
};

export default Services;